import React from "react";
import { useState, useEffect } from "react";
import { BarChart, IGroupedData } from "../Charts/BarChart";
import { BarChartWithXValuesRotate } from "../Charts/BarChartWithXValuesRotate";
import {PieChart} from "../Charts/PieChart";
import GanttChart from '../Charts/GanttChart';
import DomGanttChart, { Task } from "../Charts/DomGanttChart";
import GanttChartSVGJS from "../Charts/GanttChartSVGJS";
export function TestCharts() {
  const [BarChartDATA, setBarChartDATA] = useState<IGroupedData[]>(
    []
  );

  const [Legends, setLegends] = useState([""]);
  const [BarChartDATA2, setBarChartDATA2] = useState<IGroupedData[]>(
    []
  );

  const [Legends2, setLegends2] = useState([""]);
  const colorsForBars = [
    "#336699",
    "#E8AB59",
    "#D8DDE0",
    "#D1DB82",
    "#E2D4CB",
    "#D6EDF6",
    "#A6C3C1",
    "#D2AA87",
    "#B9e8f1",
    "#274b63",
    "#46d39a",
    "#64b5f6",
    "#BFE8FF",
    "#0075A4",
    "#FFB996",
    "#7BD3EA",
    "#B0A695",
    "#8EACCD",
  ];
  const [PieChartData, setPieChartData] = useState<any[]>([
    
  ]);
  useEffect(() => {
    setPieChartData([
      {
        name: "Cash",
        value: 33,
        color: "#E8AB59", //"#4774ab",
      },
      {
        name: "Finance",
        value: 67,
        color: "#336699",
      },
    ]);
    setBarChartDATA([
      {
        "label": "2024/25",
        "values": [
          15.12,
          7.57
        ]
      },
      {
        "label": "2025/26",
        "values": [
          15.2,
          7.37
        ]
      },
      {
        "label": "2026/27",
        "values": [
          15.15,
          7.25
        ]
      }
    ]);
    setLegends([
      "Total IPCIT",
      "Paid-out"
    ]);

    setBarChartDATA2([
      {
        "label": "2024/25",
        "values": [
          5.12,
          17.57
        ]
      },
      {
        "label": "2025/26",
        "values": [
          35.2,
          27.37
        ]
      },
      {
        "label": "2026/27",
        "values": [
          85.15,
          9.25
        ]
      }
    ]);
    setLegends2([
      "Total POT",
      "Paid-out"
    ]);
  }, []);


  const data = [
    {
      task: 'Task 1',
      start: new Date(2024, 0, 1),
      end: new Date(2024,0, 15),
      dependencies: "" // No dependencies for Task 1
    },
    {
      task: 'Task 2',
      start: new Date(2024, 0, 16),
      end: new Date(2024, 0, 31),
      dependencies: 'Task 1'// Task 2 depends on Task 1
    },
    {
      task: 'Task 3',
      start: new Date(2024, 1, 1),
      end: new Date(2024, 1, 15),
      dependencies: 'Task 1' // Task 3 depends on Task 1
    }, {
      task: 'Task 4',
      start: new Date(2024, 5, 1),
      end: new Date(2024,3, 15),
      dependencies: "" // No dependencies for Task 1
    },
    // Add more tasks as needed...
  ];
  
  const tasks: Task[] = [
    { id: 1, name: 'Task 1', start: new Date(2024, 2, 1), end: new Date(2024, 2, 4) },
    { id: 2, name: 'Task 2', start: new Date(2024, 2, 8), end: new Date(2024, 2, 14) },
    { id: 3, name: 'Task 3', start: new Date(2024, 2, 11), end: new Date(2024, 2, 21) },
  ];
  

  return (
    <div>
      <div>TestCharts</div>
  <div><GanttChart data={data}></GanttChart></div>
  <div><DomGanttChart tasks={tasks}></DomGanttChart></div>
      <div><GanttChartSVGJS></GanttChartSVGJS></div>
    </div>
  );
}
